import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppStatusRecord, AppStatusService } from '@libs/shared/api';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { extractErrorMessage } from '@libs/shared/utils/functions/error-message.util';
import { pipe, switchMap } from 'rxjs';

interface AppStatusCoreState {
  content: AppStatusRecord;
  isLoading: boolean;
  isLoaded: boolean;
  errorMessage: string;
}

const initialState: AppStatusCoreState = {
  content: undefined,
  isLoading: false,
  isLoaded: false,
  errorMessage: '',
};

@Injectable({
  providedIn: 'root',
})
export class AppStatusCoreStore {
  readonly #appStatusService = inject(AppStatusService);
  readonly #router = inject(Router);

  readonly state = signalState(initialState);
  readonly content$$ = this.state.content;
  readonly isLoading$$ = this.state.isLoading;
  readonly isLoaded$$ = this.state.isLoaded;
  readonly errorMessage$$ = this.state.errorMessage;

  constructor() {}

  fetchAppStatus = rxMethod<void>(
    pipe(
      switchMap(() =>
        this.#appStatusService.fetchAppStatus().pipe(
          tapResponse(
            (appStatus: AppStatusRecord) => {
              if (appStatus.expertAppEnabled === false) {
                this.#router.navigate(['/maintenance']);
              }
              patchState(this.state, {
                content: appStatus,
                isLoading: false,
                isLoaded: true,
                errorMessage: '',
              });
            },
            (e: HttpErrorResponse) => {
              patchState(this.state, {
                content: undefined,
                isLoading: false,
                isLoaded: false,
                errorMessage: extractErrorMessage(e),
              });
            }
          )
        )
      )
    )
  );
}
